import { Box, styled } from "@mui/material";
import { StyledComponentProps } from "../../models/Types";

interface StyledMessagePoppupProps extends StyledComponentProps {
  background: string;
}

export const StyledMessagePoppup = styled(Box)(
  ({ theme, background }: StyledMessagePoppupProps) => ({
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    top: "10rem",
    ".content": {
      width: "fit-content",
      maxWidth: "40%",
      boxShadow: `0px 0px 10px 10px ${theme.contrast.shadowColor}`,
      background: background,
      color: theme.color.background,
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      padding: "1rem 5rem",
      borderRadius: "10px",
    },
    [`@media screen and (max-width: ${theme.breakpoints.values.tablet}px)`]: {
      top: "15rem",
      ".content": {
        padding: "1rem 2rem",
        maxWidth: "95%",
        boxSizing: "border-box",
      },
    },
  })
);
